export type TPointImageBlobSize = 'tn' | 'sm' | 'md'
/**
 * Takes standard blob image URL and returns a size variant image URL
 * @param blobImageUrl image url (e.g. "https://testoilmediadev.blob.core.windows.net/asset-media/153412/aa1bc6a4-76b6-4ac1-94de-daac0fc68a95.jpg")
 */
export function getBlobImageUrl(blobImageUrl: string, size?: TPointImageBlobSize): string {
  if(!size) return blobImageUrl
  return blobImageUrl.replace(/\.jpg$/i, `/${size}.jpg`)
}
